import { forwardRef } from 'react';
import PropTypes from 'prop-types';

export const IconTimelineItem = forwardRef(
	({ width, height, className, fill }, ref) => {
		return (
			<svg
				ref={ref}
				width={width}
				height={height}
				className={className}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 36.77 36.77">
				<g transform="translate(1022.385 -1114.373) rotate(90)">
					<path
						id="outer"
						d="M0,0H21a5,5,0,0,1,5,5V26a0,0,0,0,1,0,0H5a5,5,0,0,1-5-5V0A0,0,0,0,1,0,0Z"
						transform="translate(1151.142 1004) rotate(135)"
						fill={fill}
					/>
					<path
						d="M0,0H7a3,3,0,0,1,3,3v7a0,0,0,0,1,0,0H3A3,3,0,0,1,0,7V0A0,0,0,0,1,0,0Z"
						transform="translate(1139.828 1004) rotate(135)"
						fill="#fff"
					/>
				</g>
			</svg>
		);
	}
);

IconTimelineItem.propTypes = {
	fill: PropTypes.string,
	width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

IconTimelineItem.defaultProps = {
	width: '36.77',
	height: '36.77',
	fill: '#B3997D'
};

IconTimelineItem.displayName = 'IconTimelineItem';
